// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single per-region pre-release grant — the organization sees only that one region.
 * @export
 * @interface RegionalPreRelease
 */
export interface RegionalPreRelease {
  /**
   *
   * @type {string}
   * @memberof RegionalPreRelease
   */
  cloudProvider: string;
  /**
   *
   * @type {string}
   * @memberof RegionalPreRelease
   */
  regionId: string;
  /**
   *
   * @type {string}
   * @memberof RegionalPreRelease
   */
  note?: string;
  /**
   *
   * @type {string}
   * @memberof RegionalPreRelease
   */
  createdBy: string;
  /**
   *
   * @type {Date}
   * @memberof RegionalPreRelease
   */
  createdAt: Date;
}

/**
 * Check if a given object implements the RegionalPreRelease interface.
 */
export function instanceOfRegionalPreRelease(
  value: object,
): value is RegionalPreRelease {
  if (!('cloudProvider' in value) || value['cloudProvider'] === undefined)
    return false;
  if (!('regionId' in value) || value['regionId'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  return true;
}

export function RegionalPreReleaseFromJSON(json: any): RegionalPreRelease {
  return RegionalPreReleaseFromJSONTyped(json, false);
}

export function RegionalPreReleaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RegionalPreRelease {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider: json['cloud_provider'],
    regionId: json['region_id'],
    note: json['note'] == null ? undefined : json['note'],
    createdBy: json['created_by'],
    createdAt: new Date(json['created_at']),
  };
}

export function RegionalPreReleaseToJSON(json: any): RegionalPreRelease {
  return RegionalPreReleaseToJSONTyped(json, false);
}

export function RegionalPreReleaseToJSONTyped(
  value?: RegionalPreRelease | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    region_id: value['regionId'],
    note: value['note'],
    created_by: value['createdBy'],
    created_at: value['createdAt'].toISOString(),
  };
}
